import api from "./api";

// Cart Management
const getAllCarts = async (params) => {
  const response = await api.get("/admin-cart/carts", { params });
  return response.data;
};

const getCartById = async (cartId) => {
  const response = await api.get(`/admin-cart/carts/${cartId}`);
  return response.data;
};

const getUserCart = async (userId) => {
  const response = await api.get(`/admin-cart/carts/user/${userId}`);
  return response.data;
};

const clearUserCart = async (cartId, data) => {
  const response = await api.delete(`/admin-cart/carts/${cartId}/clear`, {
    data,
  });
  return response.data;
};

// Exchange Item Verification
const getPendingExchangeItems = async (params) => {
  const response = await api.get("/admin-cart/exchange-items/pending", {
    params,
  });
  return response.data;
};

const getExchangeItemDetails = async (cartId, exchangeItemId) => {
  const response = await api.get(
    `/admin-cart/exchange-items/${cartId}/${exchangeItemId}`
  );
  return response.data;
};

const verifyExchangeItem = async (cartId, exchangeItemId, data) => {
  const response = await api.put(
    `/admin-cart/exchange-items/${cartId}/${exchangeItemId}/verify`,
    data
  );
  return response.data;
};

const rejectExchangeItem = async (cartId, exchangeItemId, data) => {
  const response = await api.put(
    `/admin-cart/exchange-items/${cartId}/${exchangeItemId}/reject`,
    data
  );
  return response.data;
};

const bulkVerifyExchangeItems = async (data) => {
  const response = await api.post(
    "/admin-cart/exchange-items/bulk-verify",
    data
  );
  return response.data;
};

// Analytics
const getCartAnalytics = async () => {
  const response = await api.get("/admin-cart/analytics/carts");
  return response.data;
};

const getAbandonedCarts = async (params) => {
  const response = await api.get("/admin-cart/analytics/abandoned-carts", {
    params,
  });
  return response.data;
};

const markAbandonedCarts = async (data) => {
  const response = await api.post("/admin-cart/analytics/mark-abandoned", data);
  return response.data;
};

const adminCartService = {
  // Cart operations
  getAllCarts,
  getCartById,
  getUserCart,
  clearUserCart,

  // Exchange item operations
  getPendingExchangeItems,
  getExchangeItemDetails,
  verifyExchangeItem,
  rejectExchangeItem,
  bulkVerifyExchangeItems,

  // Analytics operations
  getCartAnalytics,
  getAbandonedCarts,
  markAbandonedCarts,
};

export default adminCartService;
